import {call, select} from 'redux-saga/effects';
import {getActiveChildrenProductId} from 'selectors/product/product';

import {sendPDPAnalytics} from '../../homeTryOn/analytics/product/productAnalytics';

/**
 * Send analytics for product page
 */
export function* sendAnalyticsForProduct() {
    const isActiveProduct = yield select(getActiveChildrenProductId);
    if (!isActiveProduct) yield call(sendPDPAnalytics);
}
